var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgProtection = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 80 80",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M36.233 8.22C21.57 9.938 9.939 21.57 8.219 36.232L36.233 8.219ZM8.293 44.346c1.928 14.195 13.165 25.432 27.36 27.36l-27.36-27.36Zm35.042 27.481c15.01-1.554 26.94-13.483 28.493-28.493L43.335 71.828ZM71.88 37.224C70.553 21.766 58.234 9.447 42.776 8.12L71.88 37.224ZM40 0C17.909 0 0 17.909 0 40s17.909 40 40 40 40-17.909 40-40S62.091 0 40 0ZM15.513 40.253l24.042-24.042 24.041 24.042-24.041 24.042-24.042-24.042Z",
  fill: "#00C3A1"
})));

export default SvgProtection;